var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"tissue-test-single"},[_c('MetaHead'),_c('TestDetails'),_c('CropInfo'),(_vm.interpretations.length)?_c('TestResult'):_vm._e(),(_vm.interpretations.length)?_c('InterpretationChart'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }